import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './money.json';

const Money = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Financial literacy, banking, and economic vocabulary. B2 level exercises including grammar, reading, and discussion."
            level="B2"
            title="Money"
            image="/Images/money-motivation-1.webp"
            seoTitle="Free English Lesson Plans: Money"
            seoDescription="Financial literacy, banking, and economic vocabulary. B2 level exercises including grammar, reading, and discussion."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Money;


